import { ref } from 'vue';

type DialogDataType = {
  action: () => void | Promise<void>;
  title?: string;
  text?: string;
  confirmText?: string;
  cancelText?: string;
  confirmBtnVariant?: 'primary' | 'accent';
  loading?: boolean;
};

const isVisible = ref(false);
const dialogData = ref<DialogDataType>();

export default () => {
  const showConfirmationDialog = (data?: DialogDataType) => {
    dialogData.value = data;
    isVisible.value = true;
  };

  return {
    isVisible,
    dialogData,

    showConfirmationDialog,
  };
};
